import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/job-list-message.module.css';
import Slider from 'react-slick';
import './styles/react-slick-slider.css';
import JobCard from '@/components/chatbot/Layout/messages/cards/JobCard';
import BotMessage from '@/components/chatbot/Layout/messages/BotMessage';
import { addAnswer, skipBlock } from '@/store/slices/chatbotFlow';
import { connect } from 'react-redux';
import { Button } from 'antd';

const JobListMessage = props => {
  const sliderConf = {
    className: 'slider',
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  function apply(job) {
    // we use to support multiple applications for several jobs
    // Because of this, answer needs to be an array due to the parser on the backend side
    // Ask backend to update the parser to support single object as an answer
    props.addAnswer([job]);
  }

  let { data } = props;
  return data?.length > 0 ? (
    <div className={styles.wrapper}>
      <div className={styles.slider_wrapper}>
        <Slider {...sliderConf}>
          {data.map((job, i) => (
            <JobCard
              hideSalaryData={props?.block?.hide_salary_data}
              apply={apply}
              key={i}
              isActive={props.isActive}
              job={job}
            />
          ))}
        </Slider>

        {props.isActive && props.block?.skip?.enabled === true && (
          <Button type={'text'} size={'large'} danger block className={styles.button}
                  onClick={() => props?.skipBlock()}>
            {props.block?.skip?.text || 'Skip'}
          </Button>

        )}
      </div>
    </div>
  ) : (
    <BotMessage
      block={{
        message: 'We currently don’t have any roles to match your skill-set.',
      }}
      isActive={props.isActive}
    />
  );
};

JobListMessage.propTypes = {
  isActive: PropTypes.bool.isRequired,
  block: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapDispatchToProps = { skipBlock, addAnswer };

export default connect(null, mapDispatchToProps)(JobListMessage);
